export default function ImagePage() {
  return (
    <section
      className="relative h-[40vh] bg-center bg-cover bg-no-repeat text-light flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('/images/foto12.jpg')`,
        backgroundAttachment: 'fixed', // 👈 ręcznie ustawiamy fixed
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50 z-0" />

      {/* Treść hero */}
      <div className="relative z-10 text-center px-4">
        {/* Możesz tu dodać np. tytuł */}
        {/* <h1 className="text-4xl font-bold text-white">Nasza sala</h1> */}
      </div>
    </section>
  );
}
